import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { useEffect } from "react";
import { recoverFromChunkLoadError } from "@/lib/chunkLoadRecovery";

interface AppErrorFallbackProps {
  error?: unknown;
}

export function AppErrorFallback({ error }: AppErrorFallbackProps) {
  useEffect(() => {
    recoverFromChunkLoadError(error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="mx-auto h-16 w-16 rounded-full bg-destructive/10 flex items-center justify-center">
          <AlertTriangle className="h-8 w-8 text-destructive" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-foreground mb-2">Something went wrong</h1>
          <p className="text-muted-foreground">
            Our team has been notified and is looking into it. Please try reloading the page.
          </p>
        </div>
        <div className="flex justify-center gap-3">
          <Button onClick={() => window.location.reload()}>Reload page</Button>
          <Button variant="outline" onClick={() => (window.location.href = "/")}>
            Go to home
          </Button>
        </div>
        <p className="text-xs text-muted-foreground/60">AlphaSignal Analytics</p>
      </div>
    </div>
  );
}
